function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React, { useRef, CSSProperties, FC, Ref, useState, useCallback } from 'react';
import cn from 'classnames';
import { Options } from '@popperjs/core';
import { Popper, IPopperProps } from '../Popper';
import { PopupArrow as Arrow } from './Arrow/PopupArrow';
import { useIsomorphicLayoutEffect } from '../../hooks/useIsomorphicLayoutEffect';
require("./Popup.css");
var styles = {
  "defaultVariant": "Popup-module-defaultVariant_3dP",
  "darkVariant": "Popup-module-darkVariant_2Of"
};
export const PopupVariants = {
  default: 'default',
  dark: 'dark'
};
export const Popup = ({
  children,
  className,
  hasArrow = false,
  variant = PopupVariants.default,
  id,
  innerRef,
  isVisible,
  keepMounted = true,
  offset = 0,
  placement = 'bottom',
  role,
  target,
  ...props
}) => {
  const [arrowRef, setArrowRef] = useState(null);
  const [popupModifiers, setPopupModifiers] = useState(undefined);
  const popupId = useRef(id || `popup-${Math.random().toString(16).slice(-4)}`);
  const setRef = useCallback(el => {
    setArrowRef(el);
  }, []);
  useIsomorphicLayoutEffect(() => {
    setPopupModifiers([{
      name: 'arrow',
      enabled: Boolean(arrowRef) && Boolean(target),
      options: {
        element: arrowRef
      }
    }, {
      name: 'offset',
      enabled: hasArrow || offset !== 0,
      options: {
        offset: [0, offset !== 0 ? offset + 6 : 6]
      }
    }]);
  }, [hasArrow, target, arrowRef, offset]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Popper, _extends({
    target: target,
    className: cn(styles[`${variant}Variant`], className),
    keepMounted: keepMounted,
    modifiers: popupModifiers,
    isVisible: isVisible,
    placement: placement,
    innerRef: innerRef,
    role: role,
    id: popupId.current
  }, props), children, hasArrow && /*#__PURE__*/React.createElement(Arrow, {
    innerRef: setRef
  })));
};
if (process.env.NODE_ENV !== 'production') {
  Popup.displayName = 'Popup';
}